import "../auth.scss";
import React, { useState } from "react";
import { authImage, LogoImg2 } from "assets/images";
import { useNavigate, useParams } from "react-router-dom";
import { Input } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import { changePasswordApi } from "services/auth";
import { toastMessage } from "utils/toastMessage";
import usePasswordToggle from "common/UsePasswordToggle";
import { ValidateInput } from "validation";
import { auth } from "validation/schema/auth";
import commonMessages from "constants/commonMessage";
import ResetSuccess from "./ResetSuccess";

const ResetPassword = ({ data, setData, setSteps }) => {
  const [inputData, setInputData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [newPasswordToggle, newPasswordIcon] = usePasswordToggle();
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Reset");
  const [inputType, icon] = usePasswordToggle();
  const [inputType1, icon1] = usePasswordToggle();
  const [resetSuccessModal, setResetSuccessModal] = useState(false)
  // const token = localStorage.getItem("sindhiAdminToken");

  // const nevigateRoute = useNavigate();

  // Input change handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  // Input Validtion
  const validation = () => {
    const { errors, status } = ValidateInput(
      inputData,
      "resetPasswordSchema",
      auth,
      null
    );
    setError(errors);
    return status;
  };

  // Reset Password Handler

  const resetPasswordHandler = async () => {
    if (validation()) {
      try {
        if (inputData.newPassword !== inputData.confirmPassword) {
          toastMessage(
            commonMessages.NEWPASSWORD_CONFIRMPASSWORD_SAME,
            "warning",
            "reset_password"
          );
          return;
        }
        setButtonLoader(true);
        const reqData = {
          // ...inputData,
          email: data?.email,
          // token,
          password: inputData.confirmPassword,
        };
        const { data: responseData, status } = await changePasswordApi(
          reqData,
          "resetPassword_token"
        );
        console.log('responseData', responseData)
        if (status === 200) {
          // localStorage.delete("resetPassword_token");
          // toastMessage(responseData?.message, "success", "reset_password");
          // nevigateRoute("/");
          setResetSuccessModal(true)
          // setSteps(1);
        }else{
          toastMessage(responseData?.message, "error", "reset_password");
        }
      } catch (e) {
        console.log("error", e);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="auth_section">
        <div className="image_section">
          <img src={authImage} alt="" />
        </div>
        <form>
          <div className="form_title">
            <h3>Reset Password</h3>
            <p>Set up your new password to login to your business account.</p>
          </div>
          <div className="content">
            <div className="form_field has_icon">
              <Input
                className={"form-control input"}
                type={inputType}
                label="New Password"
                placeholder="Enter New Password"
                name="newPassword"
                maxLength={25}
                value={inputData?.newPassword}
                onChange={onChangeHandler}
                error={error?.newPassword}
                extraError={error?.newPasswordErr}
              />
              <span className="password_icons">{icon}</span>
            </div>
            <div className="form_field has_icon">
              <Input
                className={"form-control input"}
                type={inputType1}
                label="Confirm Password"
                placeholder="Enter Confirm Password"
                name="confirmPassword"
                maxLength={25}
                value={inputData?.confirmPassword}
                onChange={onChangeHandler}
                error={error?.confirmPassword}
                extraError={error?.confirmPasswordErr}
              />
              <span className="password_icons">{icon1}</span>
            </div>
            <div className="button_wrap">
              <button
                type="button"
                ref={buttonLoader}
                className="button"
                onClick={resetPasswordHandler}
              >
                Reset
              </button>
            </div>
          </div>
        </form>
      </div>
      <ResetSuccess
      show={resetSuccessModal}
      close={()=>setResetSuccessModal(false)}
      setSteps={setSteps}
      />
    </>
  );
};

export default ResetPassword;
